import { useUISettings } from 'dashboard/composables/useUISettings';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';

/**
 * Registers the Alt+O shortcut that toggles the conversation sidepanel
 * (Details), closing Copilot with it. Called from the views that render the
 * right-hand panel so the shortcut keeps working while the panel is closed
 * (the Details/Copilot tabs only exist when a panel is open).
 */
export function useSidepanelToggle() {
  const { uiSettings, updateUISettings } = useUISettings();

  const toggleSidepanel = () => {
    updateUISettings({
      is_contact_sidebar_open: !uiSettings.value.is_contact_sidebar_open,
      is_copilot_panel_open: false,
    });
  };

  useKeyboardEvents({
    'Alt+KeyO': { action: toggleSidepanel },
  });
}
